import { createContext, useContext } from 'react';
import Store from '@cb/solaris-react/Utility/Store';
const UserStoreContext = createContext(new Store({
    user: null,
    isLoading: false,
    error: null,
}));
export default function useUserStore() {
    const tokenStore = useContext(UserStoreContext);
    return tokenStore;
}
//# sourceMappingURL=UseUserStore.js.map